export enum NS {
  GLOBALS = 'globals',
  UI = 'ui',
  CHALLENGES = 'challenges',
  ORDERS_PAYMENTS = 'orders-payments',
  PERSONAL_INFO = 'personal-info',
  TOOLS = 'tools',
}

export enum CheckoutAction {
  NEW = 'NEW',
  EXTEND = 'EXTEND',
  RESET = 'RESET',
}

export enum ActionType {
  UpdateClient = 'update-client',
  Checkout = 'checkout',
}

export enum OfferDisplayType {
  DEFAULT = 'DEFAULT',
  EXCLUSIVE = 'EXCLUSIVE',
}

export enum AccountState {
  CREATE_FAILED = 'CREATE_FAILED',
  INITIALIZED = 'INITIALIZED',
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  PASSED = 'PASSED',
  PASSED_UNDER_REVIEW = 'PASSED_UNDER_REVIEW',
  UNDER_REVIEW = 'UNDER_REVIEW',
  PASSED_UPGRADED = 'PASSED_UPGRADED',
  BREACHED = 'BREACHED',
  PENDING_BREACHED = 'PENDING_BREACHED',
  RESET = 'RESET',
  TRANSFERRED = 'TRANSFERRED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
}

export enum LevelType {
  EARNING = 'EARNING',
  CHALLENGE = 'CHALLENGE',
}

export enum DocumentTypeId {
  IDENTIFICATION = 100,
  PROOF_OF_RESIDENCE = 101,
  BANK_ACCOUNT_CERTIFICATE = 102,
  SOLE_PROPRIETOR_TAX_FORM = 103,
  SOLE_PROPRIETOR_REGISTRATION = 104,
}

export enum DocumentProcessType {
  IDENTIFICATION = 'Identification',
  PROOF_OF_RESIDENCE = 'Proof of Residence',
  PAYMENT_ACCOUNT = 'Payment Account',
  SOLE_PROPRIETOR_TAX_FORM = 'Sole Proprietor Tax Form',
  SOLE_PROPRIETOR_REGISTRATION = 'Sole Proprietor Registration',
}

export enum PaymentAccountActionType {
  CreateBankAccount = 'create-bank-account',
  EditBankAccount = 'edit-bank-account',
  CreateCryptoAccount = 'create-crypto-account',
  EditCryptoAccount = 'edit-crypto-account',
  ArchivePaymentAccount = 'archive-payment-account',
}

export enum DocumentTypeEnum {
  SIGNAL_PROVIDER_AGREEMENT = 'SIGNAL_PROVIDER_AGREEMENT',
  CHALLENGE_CERTIFICATE = 'CHALLENGE_CERTIFICATE',
  PAYOUT_CERTIFICATE = 'PAYOUT_CERTIFICATE',
  PAYOUT_INVOICE = 'PAYOUT_INVOICE',
  PERFORMANCE_REPORT = 'PERFORMANCE_REPORT',
  CONTEST_CERTIFICATE = 'CONTEST_CERTIFICATE',
}

export enum AddonTypeEnum {
  DAY = 'DAY',
  MARKETDATA = 'MARKETDATA',
  LVSQ = 'LVSQ',
  SQBX = 'SQBX',
}

export enum SubscriptionProductStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  PENDING_APPROVAL = 'PENDING APPROVAL',
}

export enum SubscriptionProductType {
  L1 = 'L1',
  L1BUNDLE = 'L1BUNDLE',
  L2 = 'L2',
  L2CME = 'L2CME',
  EUREX = 'EUREX',
  L1NASDAQ = 'L1NASDAQ',
  L2NASDAQ = 'L2NASDAQ',
}

export enum TradingObjectiveEnum {
  ALL_POSITIONS_CLOSED = 'ALL_POSITIONS_CLOSED',
  PROFIT_TARGET = 'PROFIT_TARGET',
  MIN_TRADING_DAYS = 'MIN_TRADING_DAYS',
  MIN_PROFITABLE_DAYS = 'MIN_PROFITABLE_DAYS',
  PAYOUT_FREQUENCY = 'PAYOUT_FREQUENCY',
  ACCOUNT_ACTIVE_DAYS = 'ACCOUNT_ACTIVE_DAYS',
  MIN_WITHDRAWAL = 'MIN_WITHDRAWAL',
  CONSISTENT_PROFIT_TARGET = 'CONSISTENT_PROFIT_TARGET',
  CUMULATIVE_PROFIT_TARGET = 'CUMULATIVE_PROFIT_TARGET',
  PAYOUTS_RECEIVED = 'PAYOUTS_RECEIVED',
  BUYING_POWER_PROFIT = 'BUYING_POWER_PROFIT',
}

export enum UpgradeRequestType {
  UPGRADE_ONLY = 1,
  PAYOUT_ONLY = 2,
  UPGRADE_AND_PAYOUT = 3,
}

export enum ChallengePayoutType {
  ON_HIT_PROFIT_TARGET = 1,
  ANY_TIME_PAYOUT = 2,
}

export enum KycDocumentType {
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  OTHER = 'OTHER',
}

export enum ClientType {
  INDIVIDUAL = 1,
  SOLE_PROPRIETOR = 2,
}

export enum OrderType {
  CHALLENGE_PURCHASE = 'CHALLENGE_PURCHASE',
  SUBSCRIPTION_PURCHASE = 'SUBSCRIPTION_PURCHASE',
  PAYOUT = 'PAYOUT',
  FEE = 'FEE',
}

export enum SortBy {
  PROFIT = 'profit',
  PERCENTAGE_GAIN = 'percentageGain',
}
